module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "button-wrap toolbar",
    staticStyle: {
      "position": "absolute",
      "padding": "20px",
      "z-index": "9999"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportCounter
    }
  }, [_vm._m(0), _vm._v("\n          导出小区用水信息\n        ")])]), _vm._v(" "), _c('DataTablePage', {
    ref: "historyTable",
    attrs: {
      "mainColumn": "",
      "longColumn": "",
      "title": "小区用水统计",
      "label": "用水",
      "labelName": "",
      "resource": _vm.resource,
      "noOperationList": _vm.noOperationList,
      "tableFullList": _vm.tableFullList,
      "tableInitList": _vm.tableInitList,
      "filterInitList": _vm.filterInitList,
      "columns": _vm.columns,
      "columnHiddens": _vm.columnHiddens,
      "createFormValues": _vm.createFormValues
    },
    on: {
      "changeFormValue": _vm.changeFormValue
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btn-icon"
  }, [_c('i', {
    staticClass: "iconfont icon-export"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ebc74e2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/NB/subdistrictWaterStatistics.vue
// module id = 1807
// module chunks = 1